export const resourcesNamesStandard = [
    "forms",
    "applications",
    "applications_public",
    "analytics_public",
    "forms_public",
    "stripe_events",
    "settings",
    "support",
  ] as const;

export type ResourceNamesStandard = (typeof resourcesNamesStandard)[number];

export const possibleActions = ['list', 'show', 'edit', 'create', 'delete'] as const;
export type PossibleActions = (typeof possibleActions)[number];

export type HttpMethods = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export type ResourceName = ResourceNamesStandard;

export const resourcesConfigured = {
  applications: ['list', 'show', 'delete', 'edit'],
  applications_public: ['create', 'edit', 'show'],
  analytics_public: ['edit'],
  forms: ['create', 'show', 'list', 'delete', 'edit'],
  forms_public: ['create', 'show'],
  stripe_events: ['create'],
  settings: ['list', 'create'],
  support: ['list'],
} as const satisfies Record<ResourceName, readonly PossibleActions[]>;

export type ResourceActionMap = {
  [R in keyof typeof resourcesConfigured]: {
    resource: R;
    action: (typeof resourcesConfigured[R])[number];
  }
}[keyof typeof resourcesConfigured];

export const resourcesConfiguredPublic: Record<ResourceName, PossibleActions[]> = {
  applications: [],
  applications_public: ['create', 'edit', 'show'],
  analytics_public: ['edit'],
  forms: [],
  forms_public: ['create', 'show'],
  stripe_events: ['create'],
  settings: [],
  support: [],
};

export interface ComponentPropI {
  isPublic: boolean;
}

export const isResourceActionPublic = (resource: ResourceName, action: PossibleActions) => {
  return resourcesConfiguredPublic[resource].includes(action);
}

// Extract all valid resource-action combinations from the config
export type ConfiguredResourceActions = {
  [K in keyof typeof resourcesConfigured]:
    `${K & string}:${typeof resourcesConfigured[K][number] & string}`
}[keyof typeof resourcesConfigured];